import _ from 'lodash';
import { replace } from '../replace';
import products from '../../../services/products';
import tacHelpers from '../tacHelpers';
import addItem from './addItem';
import geometry from '../../../scene/util/geometry';
import { applicationSettings } from '../../../settings/application';
import { isSectionPosts } from '../../../services/products/elvarli';
import { ITEMS, RANGES } from '../../../constants';

function getSlotsModel(model, parent, options) {
  if (options.forceParts) {
    // We want to connect parts no matter what, so only include the parent
    return {
      ...model,
      items: model.items.filter(item => item.itemid === parent.itemid),
    };
  }

  if (options.isTopLevel) {
    // Only items colliding with our parent are interesting when connecting parts on the top level
    return {
      ...model,
      items: model.items.filter(item => geometry.collides(item, parent)),
    };
  }

  return model;
}

function getPartItem(part, parent, model, options) {
  if (options.partsToSkip?.find(partId => partId === part)) {
    return;
  }
  const partProduct = products.getProduct(part);
  if (!partProduct) {
    return;
  }
  const partIsConnectedToCeiling = part => part.logic.ceiling;
  const getSectionHeight = section => {
    return section.height;
  };
  const getSectionHeightAndPartDiff = (partProduct, section) => {
    return getSectionHeight(section) - partProduct.height;
  };

  const slotsModel = getSlotsModel(model, parent, options);

  const slots = tacHelpers.getOpenSlots(slotsModel, partProduct, {
    noVariants: true,
    proposedParent: parent,
  });
  const currentItemSlot =
    slots && slots.find(slot => slot.parent.itemid === parent.itemid);

  const offset =
    currentItemSlot &&
    tacHelpers.getGlobalCoords(currentItemSlot.parent, model);
  return (
    offset && {
      ...partProduct,
      x: currentItemSlot.x - offset.x,
      y: partIsConnectedToCeiling(partProduct)
        ? getSectionHeightAndPartDiff(partProduct, parent)
        : currentItemSlot.y - offset.y,
      z: currentItemSlot.z - offset.z,
    }
  );
}

export default function connectParts(
  newItem,
  newParent,
  oldParent,
  model,
  options
) {
  options = {
    ...options,
    isTopLevel: !tacHelpers.isItem(newParent),
  };

  Object.values(newItem.parts).forEach(part => {
    let tmpModel;
    if (oldParent === model) {
      tmpModel = newParent;
    } else {
      const clone = _.cloneDeep(model);
      replace(clone.items, newParent);
      tmpModel = clone;
    }
    newItem = tacHelpers.getItem(tmpModel, newItem.itemid);

    if (isSectionPosts(newItem)) {
      const getWallHeight = () => {
        return model.wall.size.height;
      };
      const getNewItemWithWallHeight = () => {
        return {
          ...newItem,
          height: getWallHeight(),
        };
      };
      newItem = getNewItemWithWallHeight();
    }

    const partItem = getPartItem(part, newItem, tmpModel, options);

    const shouldAddPart = () => {
      if (applicationSettings.applicationName !== RANGES.ELVARLI) return true;
      const isSectionSideUnit = item =>
        products.isType(item, ITEMS.SECTION_SIDE_UNITS);
      const isBracket = item => products.isType(item, ITEMS.BRACKET);
      if (
        isSectionSideUnit(model) ||
        (isSectionSideUnit(newParent) && isBracket(partItem))
      )
        return false;
      return true;
    };

    if (partItem && shouldAddPart()) {
      newParent = addItem(newParent, partItem, newItem, options);
    }
  });
  return newParent;
}
